function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M65 57.0573L43.0371 80.0358L68.8086 119.01L46.7188 120.534L32.7539 90.9538L30.3418 93.3659L27.5488 119.518L16.123 120.534L10.1562 51.4714L34.9121 49.9479L31.6113 81.3054L55.7324 49.9479L65 57.0573ZM123.779 119.137L85.1855 120.026L80.3613 51.4714L105.117 49.9479L97.627 111.647L124.287 108.473L123.779 119.137ZM178.369 119.137L137.617 120.026L132.793 51.4714L178.75 50.0749L178.369 57.0573L156.406 59.5964L153.74 81.1784L175.83 80.9245L176.338 90.319L152.852 88.5417L150.059 111.774L178.75 108.473L178.369 119.137ZM265.967 120.661L251.113 65.4362H250.225L238.926 119.137L229.531 120.661L207.061 69.4987H206.426L204.648 119.137L194.365 119.645L199.189 51.4714L224.326 50.4557L234.863 100.094L247.051 49.9479L272.188 51.4714L275.361 119.137L265.967 120.661ZM338.711 119.137L297.959 120.026L293.135 51.4714L339.092 50.0749L338.711 57.0573L316.748 59.5964L314.082 81.1784L336.172 80.9245L336.68 90.319L313.193 88.5417L310.4 111.774L339.092 108.473L338.711 119.137ZM413.105 50.4557L408.535 119.137L399.268 120.661L365.498 64.9284H364.736L364.99 119.137L354.707 119.645L357.5 51.4714L382.637 49.9479L400.918 101.872H401.68L402.695 50.9636L413.105 50.4557Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.6348 178.321H81.6074V158.159H74.0312V153.114H94.1934V158.159H86.6348V178.321ZM101.91 178.321H96.8652V153.114H101.91V163.203H111.982V153.114H117.027V178.321H111.982V168.248H101.91V178.321ZM139 178.321H121.721V153.114H139V158.159H126.766V163.203H135.045V168.248H126.766V173.276H139V178.321ZM79.1465 210.823C79.1465 212.018 78.9883 213.172 78.6719 214.285C78.3672 215.387 77.9336 216.424 77.3711 217.397C76.8086 218.358 76.1289 219.237 75.332 220.034C74.5352 220.83 73.6562 221.516 72.6953 222.09C71.7344 222.653 70.6973 223.086 69.584 223.391C68.4707 223.707 67.3164 223.866 66.1211 223.866C64.9258 223.866 63.7715 223.707 62.6582 223.391C61.5566 223.086 60.5195 222.653 59.5469 222.09C58.5859 221.516 57.707 220.83 56.9102 220.034C56.1133 219.237 55.4277 218.358 54.8535 217.397C54.291 216.424 53.8516 215.387 53.5352 214.285C53.2305 213.172 53.0781 212.018 53.0781 210.823C53.0781 209.627 53.2305 208.473 53.5352 207.36C53.8516 206.246 54.291 205.209 54.8535 204.248C55.4277 203.287 56.1133 202.409 56.9102 201.612C57.707 200.815 58.5859 200.135 59.5469 199.573C60.5195 199.01 61.5566 198.576 62.6582 198.272C63.7715 197.955 64.9258 197.797 66.1211 197.797C67.3164 197.797 68.4707 197.955 69.584 198.272C70.6973 198.576 71.7344 199.01 72.6953 199.573C73.6562 200.135 74.5352 200.815 75.332 201.612C76.1289 202.409 76.8086 203.287 77.3711 204.248C77.9336 205.209 78.3672 206.246 78.6719 207.36C78.9883 208.473 79.1465 209.627 79.1465 210.823ZM74.1367 210.823C74.1367 209.721 73.9258 208.684 73.5039 207.711C73.082 206.727 72.5078 205.877 71.7812 205.162C71.0664 204.436 70.2168 203.862 69.2324 203.44C68.2598 203.018 67.2227 202.807 66.1211 202.807C65.0078 202.807 63.9648 203.018 62.9922 203.44C62.0195 203.862 61.1699 204.436 60.4434 205.162C59.7168 205.877 59.1426 206.727 58.7207 207.711C58.2988 208.684 58.0879 209.721 58.0879 210.823C58.0879 211.924 58.2988 212.961 58.7207 213.934C59.1426 214.895 59.7168 215.739 60.4434 216.465C61.1699 217.192 62.0195 217.766 62.9922 218.188C63.9648 218.61 65.0078 218.821 66.1211 218.821C67.2227 218.821 68.2598 218.61 69.2324 218.188C70.2168 217.766 71.0664 217.192 71.7812 216.465C72.5078 215.739 73.082 214.895 73.5039 213.934C73.9258 212.961 74.1367 211.924 74.1367 210.823ZM87.5137 203.159V213.248H92.5586C93.25 213.248 93.9004 213.119 94.5098 212.862C95.1191 212.592 95.6523 212.229 96.1094 211.772C96.5664 211.315 96.9238 210.782 97.1816 210.172C97.4512 209.551 97.5859 208.895 97.5859 208.203C97.5859 207.512 97.4512 206.862 97.1816 206.252C96.9238 205.631 96.5664 205.092 96.1094 204.635C95.6523 204.178 95.1191 203.821 94.5098 203.563C93.9004 203.293 93.25 203.159 92.5586 203.159H87.5137ZM87.5137 223.321H82.4688V198.114H92.5586C93.4844 198.114 94.375 198.237 95.2305 198.483C96.0859 198.717 96.8828 199.057 97.6211 199.502C98.3711 199.936 99.0508 200.463 99.6602 201.084C100.281 201.694 100.809 202.373 101.242 203.123C101.688 203.873 102.027 204.676 102.262 205.532C102.508 206.387 102.631 207.278 102.631 208.203C102.631 209.071 102.52 209.914 102.297 210.735C102.086 211.555 101.775 212.334 101.365 213.073C100.967 213.811 100.475 214.491 99.8887 215.112C99.3027 215.733 98.6465 216.272 97.9199 216.729L100.715 223.321H95.3535L93.1562 218.241L87.5137 218.276V223.321ZM110.998 223.321H105.953V198.114H110.998V223.321ZM135.748 220.772C134.576 221.768 133.27 222.535 131.828 223.075C130.387 223.602 128.887 223.866 127.328 223.866C126.133 223.866 124.979 223.707 123.865 223.391C122.764 223.086 121.732 222.653 120.771 222.09C119.811 221.516 118.932 220.836 118.135 220.051C117.338 219.254 116.658 218.375 116.096 217.414C115.533 216.442 115.094 215.399 114.777 214.285C114.473 213.172 114.32 212.018 114.32 210.823C114.32 209.627 114.473 208.479 114.777 207.377C115.094 206.276 115.533 205.244 116.096 204.284C116.658 203.311 117.338 202.432 118.135 201.647C118.932 200.85 119.811 200.17 120.771 199.608C121.732 199.045 122.764 198.612 123.865 198.307C124.979 197.991 126.133 197.832 127.328 197.832C128.887 197.832 130.387 198.102 131.828 198.641C133.27 199.168 134.576 199.93 135.748 200.926L133.111 205.321C132.35 204.547 131.471 203.944 130.475 203.51C129.479 203.065 128.43 202.842 127.328 202.842C126.227 202.842 125.189 203.053 124.217 203.475C123.256 203.897 122.412 204.471 121.686 205.198C120.959 205.912 120.385 206.756 119.963 207.729C119.541 208.69 119.33 209.721 119.33 210.823C119.33 211.936 119.541 212.979 119.963 213.951C120.385 214.924 120.959 215.774 121.686 216.5C122.412 217.227 123.256 217.801 124.217 218.223C125.189 218.645 126.227 218.856 127.328 218.856C127.961 218.856 128.576 218.78 129.174 218.627C129.771 218.475 130.34 218.264 130.879 217.994V210.823H135.748V220.772ZM144.678 223.321H139.633V198.114H144.678V223.321ZM169.533 223.321H164.137L154.416 206.727V223.321H149.371V198.114H154.768L164.488 214.725V198.114H169.533V223.321Z",
  fill: "#ED3E3E"
}), /*#__PURE__*/React.createElement("g", {
  className: "watermelon"
}, /*#__PURE__*/React.createElement("path", {
  d: "M296.684 139.657L356.452 206.501L272.129 226.691L296.684 139.657Z",
  fill: "#FF4545"
}), /*#__PURE__*/React.createElement("path", {
  className: "wing1",
  d: "M386.159 124L416 232L378.201 200.114L345.873 194.457L322 168.229L386.159 124Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  className: "wing2",
  d: "M259.603 120L288 175.187L276.043 213L238.679 191.538H150L259.603 120Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  width: 88.0775,
  height: 5.11019,
  transform: "matrix(0.979932 -0.199333 0.190836 0.981622 273 225.343)",
  fill: "#80C565"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 295,
  cy: 196.5,
  rx: 2,
  ry: 2.5,
  fill: "#004122"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 295,
  cy: 196.5,
  rx: 2,
  ry: 2.5,
  fill: "#004122"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 295,
  cy: 196.5,
  rx: 2,
  ry: 2.5,
  fill: "#004122"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 319,
  cy: 189,
  r: 2,
  fill: "#004122"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 319,
  cy: 189,
  r: 2,
  fill: "#004122"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 319,
  cy: 189,
  r: 2,
  fill: "#004122"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 309,
  cy: 196.5,
  rx: 2,
  ry: 2.5,
  fill: "#004122"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 309,
  cy: 196.5,
  rx: 2,
  ry: 2.5,
  fill: "#004122"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 309,
  cy: 196.5,
  rx: 2,
  ry: 2.5,
  fill: "#004122"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 332,
  cy: 199,
  r: 2,
  fill: "#004122"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 332,
  cy: 199,
  r: 2,
  fill: "#004122"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 332,
  cy: 199,
  r: 2,
  fill: "#004122"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 299,
  cy: 208,
  r: 2,
  fill: "#004122"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 299,
  cy: 208,
  r: 2,
  fill: "#004122"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 299,
  cy: 208,
  r: 2,
  fill: "#004122"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 318,
  cy: 199,
  r: 2,
  fill: "#004122"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 318,
  cy: 199,
  r: 2,
  fill: "#004122"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 318,
  cy: 199,
  r: 2,
  fill: "#004122"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 291,
  cy: 208,
  r: 2,
  fill: "#004122"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 291,
  cy: 208,
  r: 2,
  fill: "#004122"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 291,
  cy: 208,
  r: 2,
  fill: "#004122"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0.15625,
  y: 43.9479,
  width: 425.844,
  height: 202.052,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.37 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

function SvgMasterTitle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 426,
    height: 254,
    viewBox: "0 0 426 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterTitle);
export default __webpack_public_path__ + "static/media/MasterTitle.afe449b1.svg";
export { ForwardRef as ReactComponent };